const getPrice = require('./get-price')

module.exports = (prices = [], type = 'price') => {
  return getPrice(prices, new Date().toJSON(), type)
}
